import { render, staticRenderFns } from "./bdmProfileMobile.vue?vue&type=template&id=141af10a&scoped=true&"
import script from "./bdmProfileMobile.vue?vue&type=script&lang=js&"
export * from "./bdmProfileMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141af10a",
  null
  
)

export default component.exports